module.exports = __webpack_public_path__ + "img/just-eat.6eb14b9c.png";